import ResponseErrorHandling from "../../../../helper/ResponseErrorHandling";
import commonService from "../../../../services/Common/service";
import { CommonActionTypes, UserInfoActionTypes } from "../../../action-types";

export const fetchUserInfo = () => async (dispatch) => {
  dispatch({ type: CommonActionTypes.PENDING, payload: true });

  try {
    const res = await commonService.post("/user/info");

    if (res.data.user) {
      res.data.user.sub_accounts_count = res.data.sub_accounts_count || 0;
      localStorage.setItem("userInfo", JSON.stringify({...res.data.user, client_id: res?.data.parent_client_id}));
      
      if (res.data.parent_client_id) {
        localStorage.setItem("parentClientId", res.data.parent_client_id);
      }
    }
    const userInfo = {...res.data.user, client_id: res?.data.parent_client_id};

    dispatch({
      type: UserInfoActionTypes.USER_INFO,
      payload: userInfo,
    });

    return userInfo;
  } catch (err) {
    const message = err.response.data.message || err.message;

    ResponseErrorHandling(err.response, dispatch);

    dispatch({
      type: CommonActionTypes.REJECTED,
      payload: { message, isError: true },
    });
  } finally {
    dispatch({ type: CommonActionTypes.RESET, payload: true });
  }
};
